/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Flex from 'components/common/Flex';
import React from 'react';

function CostBreakDownItem({ className, icon, itemValue, itemInfo }) {
  return (
    <div className={classNames('mb-2', className)}>
      <Flex justifyContent="between">
        <Flex alignItems="center">
          <div className="bg-secondary-lighter cost-breakdown-item">
            <FontAwesomeIcon icon={icon} className="text-1000 fs--2" />
          </div>
          {itemValue}
        </Flex>

        <div>{itemInfo}</div>
      </Flex>
    </div>
  );
}

export default CostBreakDownItem;
